import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { BASE_API, USER_TOKEN } from '../../../../../config/consts';

const URL_ADS = `${BASE_API}/station-classified-ads`;
const URL_AD = `${BASE_API}/classified-ads`;
const URL_CATEGORIES = `${BASE_API}/classified-ads-all-categories`;
const URL_CREATE_ADS = `${BASE_API}/create-ads`;
const URL_UPDATE_ADS = `${BASE_API}/update-ads`;
const URL_COMMENT = `${BASE_API}/comment-classified-ads`;

export const getClassifiedAds = (stationId) => {
  return (dispatch) => {
    dispatch({ type: 'CLASSIFIED_ADS_LOADING', payload: true });
    axios
      .get(`${URL_ADS}/${stationId}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch({
          type: 'CLASSIFIED_ADS_FETCHED',
          payload: response.data,
        });
      })
      .catch((e) => {
        dispatch({ type: 'CLASSIFIED_ADS_LOADING', payload: false });
        try {
          if (e.response.data[0]) {
            toastr.error('Erro', e.response.data[0]);
          }
        } catch (error) {
          toastr.error('Erro', 'Erro interno no servidor');
        }
      });
  };
};

export const getClassifiedAd = (id) => {
  return (dispatch) => {
    dispatch({ type: 'CLASSIFIED_AD_LOADING', payload: true });
    axios
      .get(`${URL_AD}/${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch({
          type: 'CLASSIFIED_AD_FETCHED',
          payload: response.data,
        });
      })
      .catch((e) => {
        dispatch({ type: 'CLASSIFIED_AD_LOADING', payload: false });
        try {
          if (e.response.data[0]) {
            toastr.error('Erro', e.response.data[0]);
          }
        } catch (error) {
          toastr.error('Erro', 'Erro interno no servidor');
        }
      });
  };
};

export const getCategories = () => {
  return (dispatch) => {
    axios
      .get(URL_CATEGORIES, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch({
          type: 'CLASSIFIED_ADS_CATEGORIES_FETCHED',
          payload: response.data,
        });
      })
      .catch((e) => {
        try {
          if (e.response.data[0]) {
            toastr.error('Erro', e.response.data[0]);
          }
        } catch (error) {
          toastr.error('Erro', 'Erro interno no servidor');
        }
      });
  };
};

export const createClassifiedAd = (values, stationId) => {
  return (dispatch) => {
    dispatch({ type: 'CLASSIFIED_AD_SUBMITTING', payload: true });
    axios
      .post(URL_CREATE_ADS, values, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        toastr.success('Sucesso', 'Anúncio criado com sucesso!');
        dispatch({ type: 'CLASSIFIED_AD_SUBMITTING', payload: false });
        dispatch(getClassifiedAds(stationId));
      })
      .catch((e) => {
        dispatch({ type: 'CLASSIFIED_AD_SUBMITTING', payload: false });
        try {
          if (e.response.data[0]) {
            toastr.error('Erro', e.response.data[0]);
          }
        } catch (error) {
          toastr.error('Erro', 'Erro ao criar anúncio');
        }
      });
  };
};

export const deleteClassifiedAd = (id, stationId) => {
  return (dispatch) => {
    axios
      .delete(`${URL_AD}/${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        toastr.success('Sucesso', 'Anúncio removido com sucesso!');
        dispatch(getClassifiedAds(stationId));
      })
      .catch((e) => {
        try {
          if (e.response.data[0]) {
            toastr.error('Erro', e.response.data[0]);
          }
        } catch (error) {
          toastr.error('Erro', 'Erro ao remover anúncio');
        }
      });
  };
};

export const createComment = (classifiedAdId, description, stationId) => {
  return (dispatch) => {
    dispatch({ type: 'CLASSIFIED_AD_COMMENT_SUBMITTING', payload: true });
    axios
      .post(
        `${URL_COMMENT}/${classifiedAdId}`,
        { description },
        {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        }
      )
      .then((response) => {
        toastr.success('Sucesso', 'Comentário enviado!');
        dispatch({ type: 'CLASSIFIED_AD_COMMENT_SUBMITTING', payload: false });
        dispatch(getClassifiedAd(classifiedAdId));
      })
      .catch((e) => {
        dispatch({ type: 'CLASSIFIED_AD_COMMENT_SUBMITTING', payload: false });
        try {
          if (e.response.data[0]) {
            toastr.error('Erro', e.response.data[0]);
          }
        } catch (error) {
          toastr.error('Erro', 'Erro ao enviar comentário');
        }
      });
  };
};

export const deleteComment = (commentId, classifiedAdId) => {
  return (dispatch) => {
    axios
      .delete(`${URL_COMMENT}/${commentId}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        toastr.success('Sucesso', 'Comentário removido!');
        dispatch(getClassifiedAd(classifiedAdId));
      })
      .catch((e) => {
        try {
          if (e.response.data[0]) {
            toastr.error('Erro', e.response.data[0]);
          }
        } catch (error) {
          toastr.error('Erro', 'Erro ao remover comentário');
        }
      });
  };
};
